import * as React from 'react'
import { useEffect } from 'react'
import { Box, Grid } from '@mui/material'

import { COMPONENTS } from './@constants'
import { filterComponents } from '@signals/commonFilters'
import CommonFiltersFooterActions from '@components/NewCommonFilters/FooterActions'
import { ShowFeatures } from '@components/CommonFilters/@components'
import { showFeatures } from '@signals'

export default function AppCommonFilters(
	{
		components = [],
		containerProps = {},
		featuresComponents = [],
		headerComponents = [],
		Footer = CommonFiltersFooterActions,
	}) {

	useEffect(() => {
		filterComponents.value = components.map((comp) => comp.name)
	}, [components])

	const renderComponents = (items) =>
		items.map(({ name, grid = {}, ...props }, idx) => {
			if (name === "blank") return <Grid key={idx} item xs={4} {...grid} />
			const Component = COMPONENTS[name]
			if (!Component) return null
			return (
				<Grid key={idx} item xs={4} {...grid}>
					<Component {...props} />
				</Grid>
			)
		})

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 2 }} {...containerProps}>
			{headerComponents.length > 0 && <Grid container spacing={2}>{renderComponents(headerComponents)}</Grid>}
			<Grid container spacing={2}>{renderComponents(components)}</Grid>
			{featuresComponents.length > 0 && (
				<Grid container spacing={2}>
					<Grid item xs={2}>
						<ShowFeatures/>
					</Grid>
					<Grid item xs={10}/>
					{showFeatures.value && renderComponents(featuresComponents)}
				</Grid>
			)}
			<Grid container spacing={2}>
				<Grid
					item
					xs={12}
					sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
				>
					<Footer/>
				</Grid>
			</Grid>
		</Box>
	)
}
